export default "__VITE_ASSET__BlPx$wG3__"